/* @ngInject */

export default (
  $rootScope,
  dateTimeService,
  FeeAndCharge,
  helperService,
  HomeLoanVerificationApplicant,
  Address,
  YesNoOption
) => {
  /*
   * Constructor
   * --------------------------------------------------------------------------------
   */
  function HomeLoanCompliance(
    comments,
    monthlyFinancialPosition,
    verifications,
    interestDisclosure,
    productSuitability,
    feesAndCharges,
    riskBenefitStatements,
    brokerDisclosure
  ) {
    this.organizationCountry = helperService.getOrganizationCountry().cca2;
    this.comments = comments;
    this.monthlyFinancialPosition = monthlyFinancialPosition;
    this.verifications = verifications;
    this.interestDisclosure = interestDisclosure;
    this.productSuitability = productSuitability;
    this.feesAndCharges = feesAndCharges;
    this.riskBenefitStatements = riskBenefitStatements;
    this.brokerDisclosure = brokerDisclosure;

    if (
      this.verifications &&
      this.verifications.applicants &&
      this.verifications.applicants.length
    ) {
      this.verifications.applicants = _.map(
        _.compact(this.verifications.applicants),
        (verificationApplicant) => HomeLoanVerificationApplicant.Build(verificationApplicant)
      );
    }

    if (!this.verifications?.interviewDetailsCustomersSpeakAndUnderstandEnglishFluently) {
      this.verifications.interviewDetailsCustomersSpeakAndUnderstandEnglishFluently = '';
    }
    if (!this.verifications?.interviewDetailsInterviewWasConductedInTheFollowingLanguage) {
      this.verifications.interviewDetailsInterviewWasConductedInTheFollowingLanguage = '';
    }
    if (!this.verifications?.interviewDetailsInterviewIsBrokerFluentInThisLanguage) {
      this.verifications.interviewDetailsInterviewIsBrokerFluentInThisLanguage = '';
    }
    if (!this.verifications?.interviewDetailsInterviewWasTranslatorUsed) {
      this.verifications.interviewDetailsInterviewWasTranslatorUsed = '';
    }

    if (!this.comments?.lenderSelectionJustification) {
      this.comments.lenderSelectionJustification = undefined;
    }
    if (!this.comments?.productSelectionJustification) {
      this.comments.productSelectionJustification = undefined;
    }
    if (!this.comments?.analysisAssessmentAndApplicantEducation) {
      this.comments.analysisAssessmentAndApplicantEducation = '';
    }
    if (!this.comments?.optionsPresentedAndRecommendation) {
      this.comments.optionsPresentedAndRecommendation = '';
    }

    switch (this.interestDisclosure?.isConflict) {
      case true:
        this.interestDisclosure.isConflict = YesNoOption.yes;
        break;
      case false:
        this.interestDisclosure.isConflict = YesNoOption.no;
        break;
      default:
        this.interestDisclosure.isConflict = YesNoOption.of(
          this.interestDisclosure?.isConflict?.name
        );
        break;
    }

    if (this.interestDisclosure?.lenderConflictOfInterest === undefined) {
      this.interestDisclosure.lenderConflictOfInterest = false;
    }
    if (this.interestDisclosure?.lenderConflictOfInterestComments === undefined) {
      this.interestDisclosure.lenderConflictOfInterestComments = '';
    }
    if (this.interestDisclosure?.referralConflictOfInterest === undefined) {
      this.interestDisclosure.referralConflictOfInterest = false;
    }
    if (this.interestDisclosure?.referralConflictOfInterestComments === undefined) {
      this.interestDisclosure.referralConflictOfInterestComments = '';
    }
    if (this.interestDisclosure?.otherConflictOfInterest === undefined) {
      this.interestDisclosure.otherConflictOfInterest = false;
    }
    if (this.interestDisclosure?.otherConflictOfInterestComments === undefined) {
      this.interestDisclosure.otherConflictOfInterestComments = '';
    }

    if (_.isEmpty(this.brokerDisclosure)) {
      this.brokerDisclosure.designDistributionObligations = YesNoOption.none;
      this.brokerDisclosure.designDistributionObligationsComments = '';
      this.brokerDisclosure.capitalisationOfFees = YesNoOption.none;
      this.brokerDisclosure.capitalisationOfFeesComments = '';
    } else {
      this.brokerDisclosure.designDistributionObligations = YesNoOption.of(
        this.brokerDisclosure?.designDistributionObligations?.name
      );
      this.brokerDisclosure.designDistributionObligationsComments =
        this.brokerDisclosure?.designDistributionObligationsComments || '';
      this.brokerDisclosure.capitalisationOfFees = YesNoOption.of(
        this.brokerDisclosure?.capitalisationOfFees?.name
      );
      this.brokerDisclosure.capitalisationOfFeesComments =
        this.brokerDisclosure?.capitalisationOfFeesComments || '';
    }
  }

  /*
   * Static methods
   * --------------------------------------------------------------------------------
   */
  HomeLoanCompliance.Blank = function () {
    return HomeLoanCompliance.Build({
      comments: {
        analysisAssessmentAndApplicantEducation: '',
        optionsPresentedAndRecommendation: '',
        borrowingPower: '',
        depositOrEquity: '',
        creditHistory: '',
        security: '',
        applicationSubmission: '',
        fixedProduct: '',
        interestOnlyProduct: '',
        lineOfCredit: '',
        interestInAdvance: '',
        livingExpenses: '',
        switchRefix: '',
        lenderSelectionJustification: '',
        productSelectionJustification: ''
      },
      monthlyFinancialPosition: {
        netIncome: {
          currentPosition: 0,
          proposedPosition: 0,
          proposedPositionAtBufferRate: 0,
          comments: ''
        },
        lessTotalCurrentRepayment: {
          currentPosition: 0,
          proposedPosition: 0,
          proposedPositionAtBufferRate: 0,
          comments: ''
        },
        lessTotalProposedRepayment: {
          currentPosition: 0,
          proposedPosition: 0,
          proposedPositionAtBufferRate: 0,
          comments: ''
        },
        lessTotalCurrentExpenses: {
          currentPosition: 0,
          proposedPosition: 0,
          proposedPositionAtBufferRate: 0,
          comments: ''
        },
        foreseeableFinancialChanges: {
          debtCommitmentsCeasing: {
            currentPosition: 0,
            proposedPosition: 0,
            proposedPositionAtBufferRate: 0,
            comments: ''
          },
          incomeIncreasing: {
            currentPosition: 0,
            proposedPosition: 0,
            proposedPositionAtBufferRate: 0,
            comments: ''
          },
          expenseDecreasing: {
            currentPosition: 0,
            proposedPosition: 0,
            proposedPositionAtBufferRate: 0,
            comments: ''
          },
          newDebtCommitments: {
            currentPosition: 0,
            proposedPosition: 0,
            proposedPositionAtBufferRate: 0,
            comments: ''
          },
          incomeDecreasing: {
            currentPosition: 0,
            proposedPosition: 0,
            proposedPositionAtBufferRate: 0,
            comments: ''
          },
          expenseIncreasing: {
            currentPosition: 0,
            proposedPosition: 0,
            proposedPositionAtBufferRate: 0,
            comments: ''
          },
          total: {
            currentPosition: 0,
            proposedPosition: 0,
            proposedPositionAtBufferRate: 0
          }
        },
        surplusDeficit: {
          currentPosition: 0,
          proposedPosition: 0,
          proposedPositionAtBufferRate: 0,
          comments: ''
        },
        totalAssets: 0,
        totalLiabilities: 0,
        netAssetPosition: 0,
        totalOutgoings: 0,
        netCashPosition: 0,
        financialRisk: 0,
        hemVariance: 0,
        debtToIncomeRatio: 0,
        totalWords: 0
      },
      verifications: {
        applicants: [],
        interviewDetailsMethod: '',
        interviewDetailsAttendees: '',
        interviewDetailsLocation: Address.blank(),
        interviewDetailsDateVerified: 0,
        interviewDetailsCustomersSpeakAndUnderstandEnglishFluently: '',
        interviewDetailsInterviewWasConductedInTheFollowingLanguage: '',
        interviewDetailsInterviewIsBrokerFluentInThisLanguage: '',
        interviewDetailsInterviewWasTranslatorUsed: '',
        antiMoneyLaunderingChecksCompleted: '',
        antiMoneyLaunderingChecksCompletedVerificationMethod: '',
        antiMoneyLaunderingChecksCompletedDateVerified: 0,
        creditChecksCompleted: '',
        creditChecksCompletedVerificationMethod: '',
        creditChecksCompletedDateVerified: 0,
        propertySearchesCompleted: '',
        propertySearchesCompletedVerificationMethod: '',
        propertySearchesCompletedDateVerified: 0,
        employmentVerificationMethod: '',
        employmentVerificationDateVerified: 0,
        incomeVerificationCompleted: '',
        incomeVerificationCompletedVerificationMethod: '',
        incomeVerificationCompletedDateVerified: 0,
        livingExpensesVerified: '',
        livingExpensesVerifiedVerificationMethod: '',
        livingExpensesVerifiedDateVerified: 0
      },
      interestDisclosure: {
        isConflict: YesNoOption.none,
        lenderConflictOfInterest: false,
        lenderConflictOfInterestComments: '',
        referralConflictOfInterest: false,
        referralConflictOfInterestComments: '',
        otherConflictOfInterest: false,
        otherConflictOfInterestComments: '',
        comments: ''
      },
      productSuitability: {
        isUnsuitable: null,
        isProductInconsistent: false,
        isApplicantComply: false
      },
      feesAndCharges: [],
      riskBenefitStatements: {
        basicVariableRateLoans: false,
        fixedRateLoans: false,
        interestOnlyLoans: false,
        introductoryRateLoans: false,
        lineOfCredit: false,
        offsetAccountFacilities: false,
        variableRateLoans: false,
        redraw: false
      },
      brokerDisclosure: {
        designDistributionObligations: YesNoOption.none,
        designDistributionObligationsComments: '',
        capitalisationOfFees: YesNoOption.none,
        capitalisationOfFeesComments: ''
      }
    });
  };
  HomeLoanCompliance.Build = function (data) {
    return new HomeLoanCompliance(
      data.comments
        ? data.comments
        : {
            analysisAssessmentAndApplicantEducation: '',
            optionsPresentedAndRecommendation: '',
            borrowingPower: '',
            depositOrEquity: '',
            creditHistory: '',
            security: '',
            applicationSubmission: '',
            fixedProduct: '',
            interestOnlyProduct: '',
            lineOfCredit: '',
            interestInAdvance: '',
            livingExpenses: '',
            switchRefix: '',
            lenderSelectionJustification: '',
            productSelectionJustification: ''
          },
      data.monthlyFinancialPosition
        ? data.monthlyFinancialPosition
        : {
            netIncome: {
              currentPosition: 0,
              proposedPosition: 0,
              proposedPositionAtBufferRate: 0,
              comments: ''
            },
            lessTotalCurrentRepayment: {
              currentPosition: 0,
              proposedPosition: 0,
              proposedPositionAtBufferRate: 0,
              comments: ''
            },
            lessTotalProposedRepayment: {
              currentPosition: 0,
              proposedPosition: 0,
              proposedPositionAtBufferRate: 0,
              comments: ''
            },
            lessTotalCurrentExpenses: {
              currentPosition: 0,
              proposedPosition: 0,
              proposedPositionAtBufferRate: 0,
              comments: ''
            },
            foreseeableFinancialChanges: {
              debtCommitmentsCeasing: {
                currentPosition: 0,
                proposedPosition: 0,
                proposedPositionAtBufferRate: 0,
                comments: ''
              },
              incomeIncreasing: {
                currentPosition: 0,
                proposedPosition: 0,
                proposedPositionAtBufferRate: 0,
                comments: ''
              },
              expenseDecreasing: {
                currentPosition: 0,
                proposedPosition: 0,
                proposedPositionAtBufferRate: 0,
                comments: ''
              },
              newDebtCommitments: {
                currentPosition: 0,
                proposedPosition: 0,
                proposedPositionAtBufferRate: 0,
                comments: ''
              },
              incomeDecreasing: {
                currentPosition: 0,
                proposedPosition: 0,
                proposedPositionAtBufferRate: 0,
                comments: ''
              },
              expenseIncreasing: {
                currentPosition: 0,
                proposedPosition: 0,
                proposedPositionAtBufferRate: 0,
                comments: ''
              },
              total: {
                currentPosition: 0,
                proposedPosition: 0,
                proposedPositionAtBufferRate: 0
              }
            },
            surplusDeficit: {
              currentPosition: 0,
              proposedPosition: 0,
              proposedPositionAtBufferRate: 0,
              comments: ''
            },
            totalAssets: 0,
            totalLiabilities: 0,
            netAssetPosition: 0,
            totalOutgoings: 0,
            netCashPosition: 0,
            financialRisk: 0,
            hemVariance: 0,
            debtToIncomeRatio: 0,
            totalWords: 0
          },
      data.verifications
        ? data.verifications
        : {
            applicants: [],
            interviewDetailsMethod: '',
            interviewDetailsAttendees: '',
            interviewDetailsLocation: Address.blank(),
            interviewDetailsDateVerified: 0,
            interviewDetailsCustomersSpeakAndUnderstandEnglishFluently: '',
            interviewDetailsInterviewWasConductedInTheFollowingLanguage: '',
            interviewDetailsInterviewIsBrokerFluentInThisLanguage: '',
            interviewDetailsInterviewWasTranslatorUsed: '',
            antiMoneyLaunderingChecksCompleted: '',
            antiMoneyLaunderingChecksCompletedVerificationMethod: '',
            antiMoneyLaunderingChecksCompletedDateVerified: 0,
            creditChecksCompleted: '',
            creditChecksCompletedVerificationMethod: '',
            creditChecksCompletedDateVerified: 0,
            propertySearchesCompleted: '',
            propertySearchesCompletedVerificationMethod: '',
            propertySearchesCompletedDateVerified: 0,
            employmentVerificationMethod: '',
            employmentVerificationDateVerified: 0,
            incomeVerificationCompleted: '',
            incomeVerificationCompletedVerificationMethod: '',
            incomeVerificationCompletedDateVerified: 0,
            livingExpensesVerified: '',
            livingExpensesVerifiedVerificationMethod: '',
            livingExpensesVerifiedDateVerified: 0
          },
      data.interestDisclosure
        ? data.interestDisclosure
        : {
            isConflict: YesNoOption.none,
            lenderConflictOfInterest: false,
            lenderConflictOfInterestComments: '',
            referralConflictOfInterest: false,
            referralConflictOfInterestComments: '',
            otherConflictOfInterest: false,
            otherConflictOfInterestComments: '',
            comments: ''
          },
      data.productSuitability
        ? data.productSuitability
        : {
            isUnsuitable: null,
            isProductInconsistent: false,
            isApplicantComply: false
          },
      _.map(_.compact(data.feesAndCharges), (feeAndCharge) => FeeAndCharge.Build(feeAndCharge)),
      data.riskBenefitStatements
        ? data.riskBenefitStatements
        : {
            basicVariableRateLoans: false,
            fixedRateLoans: false,
            interestOnlyLoans: false,
            introductoryRateLoans: false,
            lineOfCredit: false,
            offsetAccountFacilities: false,
            variableRateLoans: false,
            redraw: false
          },
      data.brokerDisclosure
        ? data.brokerDisclosure
        : {
            designDistributionObligations: YesNoOption.none,
            designDistributionObligationsComments: '',
            capitalisationOfFees: YesNoOption.none,
            capitalisationOfFeesComments: ''
          }
    );
  };

  /*
   * Public methods
   * --------------------------------------------------------------------------------
   */
  HomeLoanCompliance.prototype.getSetVerificationsInterviewDetailsDate = function (date) {
    if (arguments.length) {
      if (arguments[0] !== null) {
        if (!this.verifications.interviewDetailsDateVerified) {
          this.verifications.interviewDetailsDateVerifiedObject = '';
        }
        const interviewDetailsDateVerifiedObject = dateTimeService.setDate(
          date,
          $rootScope.CurrentTimeZone(),
          true
        );
        this.verifications.interviewDetailsDateVerifiedObject = date;
        this.verifications.interviewDetailsDateVerified = moment
          .utc(interviewDetailsDateVerifiedObject)
          .startOf('day')
          .format('X');
      } else {
        this.verifications.interviewDetailsDateVerifiedObject = date;
        this.verifications.interviewDetailsDateVerified = 0;
      }
    }
    if (!this.verifications.interviewDetailsDateVerifiedObject) {
      if (this.verifications.interviewDetailsDateVerified) {
        const interviewDetailsDateVerifiedObject = dateTimeService.setDate(
          this.verifications.interviewDetailsDateVerified,
          $rootScope.CurrentTimeZone(),
          false
        );
        this.verifications.interviewDetailsDateVerifiedObject = interviewDetailsDateVerifiedObject;
      } else {
        this.verifications.interviewDetailsDateVerifiedObject = '';
      }
    }
    return this.verifications.interviewDetailsDateVerifiedObject;
  };
  HomeLoanCompliance.prototype.getSetVerificationsAntiMoneyLaunderingChecksCompletedDate = function (
    date
  ) {
    if (arguments.length) {
      if (arguments[0] !== null) {
        if (!this.verifications.antiMoneyLaunderingChecksCompletedDateVerified) {
          this.verifications.antiMoneyLaunderingChecksCompletedDateVerifiedObject = '';
        }
        const antiMoneyLaunderingChecksCompletedDateVerifiedObject = dateTimeService.setDate(
          date,
          $rootScope.CurrentTimeZone(),
          true
        );
        this.verifications.antiMoneyLaunderingChecksCompletedDateVerifiedObject = date;
        this.verifications.antiMoneyLaunderingChecksCompletedDateVerified = moment
          .utc(antiMoneyLaunderingChecksCompletedDateVerifiedObject)
          .startOf('day')
          .format('X');
      } else {
        this.verifications.antiMoneyLaunderingChecksCompletedDateVerifiedObject = date;
        this.verifications.antiMoneyLaunderingChecksCompletedDateVerified = 0;
      }
    }
    if (!this.verifications.antiMoneyLaunderingChecksCompletedDateVerifiedObject) {
      if (this.verifications.antiMoneyLaunderingChecksCompletedDateVerified) {
        const antiMoneyLaunderingChecksCompletedDateVerifiedObject = dateTimeService.setDate(
          this.verifications.antiMoneyLaunderingChecksCompletedDateVerified,
          $rootScope.CurrentTimeZone(),
          false
        );
        this.verifications.antiMoneyLaunderingChecksCompletedDateVerifiedObject = antiMoneyLaunderingChecksCompletedDateVerifiedObject;
      } else {
        this.verifications.antiMoneyLaunderingChecksCompletedDateVerifiedObject = '';
      }
    }
    return this.verifications.antiMoneyLaunderingChecksCompletedDateVerifiedObject;
  };
  HomeLoanCompliance.prototype.getSetVerificationsCreditChecksCompletedDate = function (date) {
    if (arguments.length) {
      if (arguments[0] !== null) {
        if (!this.verifications.creditChecksCompletedDateVerified) {
          this.verifications.creditChecksCompletedDateVerifiedObject = '';
        }
        const creditChecksCompletedDateVerifiedObject = dateTimeService.setDate(
          date,
          $rootScope.CurrentTimeZone(),
          true
        );
        this.verifications.creditChecksCompletedDateVerifiedObject = date;
        this.verifications.creditChecksCompletedDateVerified = moment
          .utc(creditChecksCompletedDateVerifiedObject)
          .startOf('day')
          .format('X');
      } else {
        this.verifications.creditChecksCompletedDateVerifiedObject = date;
        this.verifications.creditChecksCompletedDateVerified = 0;
      }
    }
    if (!this.verifications.creditChecksCompletedDateVerifiedObject) {
      if (this.verifications.creditChecksCompletedDateVerified) {
        const creditChecksCompletedDateVerifiedObject = dateTimeService.setDate(
          this.verifications.creditChecksCompletedDateVerified,
          $rootScope.CurrentTimeZone(),
          false
        );
        this.verifications.creditChecksCompletedDateVerifiedObject = creditChecksCompletedDateVerifiedObject;
      } else {
        this.verifications.creditChecksCompletedDateVerifiedObject = '';
      }
    }
    return this.verifications.creditChecksCompletedDateVerifiedObject;
  };
  HomeLoanCompliance.prototype.getSetVerificationsPropertySearchesCompletedDate = function (
    date
  ) {
    if (arguments.length) {
      if (arguments[0] !== null) {
        if (!this.verifications.propertySearchesCompletedDateVerified) {
          this.verifications.propertySearchesCompletedDateVerifiedObject = '';
        }
        const propertySearchesCompletedDateVerifiedObject = dateTimeService.setDate(
          date,
          $rootScope.CurrentTimeZone(),
          true
        );
        this.verifications.propertySearchesCompletedDateVerifiedObject = date;
        this.verifications.propertySearchesCompletedDateVerified = moment
          .utc(propertySearchesCompletedDateVerifiedObject)
          .startOf('day')
          .format('X');
      } else {
        this.verifications.propertySearchesCompletedDateVerifiedObject = date;
        this.verifications.propertySearchesCompletedDateVerified = 0;
      }
    }
    if (!this.verifications.propertySearchesCompletedDateVerifiedObject) {
      if (this.verifications.propertySearchesCompletedDateVerified) {
        const propertySearchesCompletedDateVerifiedObject = dateTimeService.setDate(
          this.verifications.propertySearchesCompletedDateVerified,
          $rootScope.CurrentTimeZone(),
          false
        );
        this.verifications.propertySearchesCompletedDateVerifiedObject = propertySearchesCompletedDateVerifiedObject;
      } else {
        this.verifications.propertySearchesCompletedDateVerifiedObject = '';
      }
    }
    return this.verifications.propertySearchesCompletedDateVerifiedObject;
  };
  HomeLoanCompliance.prototype.getSetVerificationsEmploymentVerificationDate = function (date) {
    if (arguments.length) {
      if (arguments[0] !== null) {
        if (!this.verifications.employmentVerificationDateVerified) {
          this.verifications.employmentVerificationDateVerifiedObject = '';
        }
        const employmentVerificationDateVerifiedObject = dateTimeService.setDate(
          date,
          $rootScope.CurrentTimeZone(),
          true
        );
        this.verifications.employmentVerificationDateVerifiedObject = date;
        this.verifications.employmentVerificationDateVerified = moment
          .utc(employmentVerificationDateVerifiedObject)
          .startOf('day')
          .format('X');
      } else {
        this.verifications.employmentVerificationDateVerifiedObject = date;
        this.verifications.employmentVerificationDateVerified = 0;
      }
    }
    if (!this.verifications.employmentVerificationDateVerifiedObject) {
      if (this.verifications.employmentVerificationDateVerified) {
        const employmentVerificationDateVerifiedObject = dateTimeService.setDate(
          this.verifications.employmentVerificationDateVerified,
          $rootScope.CurrentTimeZone(),
          false
        );
        this.verifications.employmentVerificationDateVerifiedObject = employmentVerificationDateVerifiedObject;
      } else {
        this.verifications.employmentVerificationDateVerifiedObject = '';
      }
    }
    return this.verifications.employmentVerificationDateVerifiedObject;
  };
  HomeLoanCompliance.prototype.getSetVerificationsIncomeVerificationCompletedDate = function (
    date
  ) {
    if (arguments.length) {
      if (arguments[0] !== null) {
        if (!this.verifications.incomeVerificationCompletedDateVerified) {
          this.verifications.incomeVerificationCompletedDateVerifiedObject = '';
        }
        const incomeVerificationCompletedDateVerifiedObject = dateTimeService.setDate(
          date,
          $rootScope.CurrentTimeZone(),
          true
        );
        this.verifications.incomeVerificationCompletedDateVerifiedObject = date;
        this.verifications.incomeVerificationCompletedDateVerified = moment
          .utc(incomeVerificationCompletedDateVerifiedObject)
          .startOf('day')
          .format('X');
      } else {
        this.verifications.incomeVerificationCompletedDateVerifiedObject = date;
        this.verifications.incomeVerificationCompletedDateVerified = 0;
      }
    }
    if (!this.verifications.incomeVerificationCompletedDateVerifiedObject) {
      if (this.verifications.incomeVerificationCompletedDateVerified) {
        const incomeVerificationCompletedDateVerifiedObject = dateTimeService.setDate(
          this.verifications.incomeVerificationCompletedDateVerified,
          $rootScope.CurrentTimeZone(),
          false
        );
        this.verifications.incomeVerificationCompletedDateVerifiedObject = incomeVerificationCompletedDateVerifiedObject;
      } else {
        this.verifications.incomeVerificationCompletedDateVerifiedObject = '';
      }
    }
    return this.verifications.incomeVerificationCompletedDateVerifiedObject;
  };
  HomeLoanCompliance.prototype.getSetVerificationsLivingExpensesVerifiedDate = function (date) {
    if (arguments.length) {
      if (arguments[0] !== null) {
        if (!this.verifications.livingExpensesVerifiedDateVerified) {
          this.verifications.livingExpensesVerifiedDateVerifiedObject = '';
        }
        const livingExpensesVerifiedDateVerifiedObject = dateTimeService.setDate(
          date,
          $rootScope.CurrentTimeZone(),
          true
        );
        this.verifications.livingExpensesVerifiedDateVerifiedObject = date;
        this.verifications.livingExpensesVerifiedDateVerified = moment
          .utc(livingExpensesVerifiedDateVerifiedObject)
          .startOf('day')
          .format('X');
      } else {
        this.verifications.livingExpensesVerifiedDateVerifiedObject = date;
        this.verifications.livingExpensesVerifiedDateVerified = 0;
      }
    }
    if (!this.verifications.livingExpensesVerifiedDateVerifiedObject) {
      if (this.verifications.livingExpensesVerifiedDateVerified) {
        const livingExpensesVerifiedDateVerifiedObject = dateTimeService.setDate(
          this.verifications.livingExpensesVerifiedDateVerified,
          $rootScope.CurrentTimeZone(),
          false
        );
        this.verifications.livingExpensesVerifiedDateVerifiedObject = livingExpensesVerifiedDateVerifiedObject;
      } else {
        this.verifications.livingExpensesVerifiedDateVerifiedObject = '';
      }
    }
    return this.verifications.livingExpensesVerifiedDateVerifiedObject;
  };
  HomeLoanCompliance.prototype.deleteDateObject = function () {
    for (let a = 0; a < this.verifications.applicants.length; a += 1) {
      delete this.verifications.applicants[a].dateVerifiedObject;
    }
    delete this.verifications.interviewDetailsDateVerifiedObject;
    delete this.verifications.antiMoneyLaunderingChecksCompletedDateVerifiedObject;
    delete this.verifications.creditChecksCompletedDateVerifiedObject;
    delete this.verifications.propertySearchesCompletedDateVerifiedObject;
    delete this.verifications.employmentVerificationDateVerifiedObject;
    delete this.verifications.incomeVerificationCompletedDateVerifiedObject;
    delete this.verifications.livingExpensesVerifiedDateVerifiedObject;
  };

  return HomeLoanCompliance;
};
